import React, { Component } from 'react';
import { Input, Tag, Radio, Select } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new';
import RelateJdeCode from './RelateJdeCode';
import Text from '../../../basicElement/Text';
import API_URL from '../../../../common/url';
import { RelateType } from '../constants';
import $ from '../../../../common/AjaxRequest';

const RadioGroup = Radio.Group;
const Option = Select.Option;
class AddFromBlind extends Component {
    handleClick = () => {
        const { data } = this.props;
        this.relateTypeRef.show(data.contractVos);
    }

    handleDelete = index => {
        const { data, onChange } = this.props;
        const { contractVos } = data;
        contractVos.splice(index, 1);
        onChange(data);
    }

    handleChange = (value, key) => {
        const { data, onChange } = this.props;
        switch (key) {
        case 'site': {
            const { value: id, text: name, unblindingRisk, unblindingRiskLevelShow } = value;
            data.siteId = id;
            data.siteName = name;
            data.unblindingRisk = unblindingRisk;
            data.unblindingRiskLevelShow = unblindingRiskLevelShow;
            break;
        }
        default: {
            data[key] = value;
            break;
        }
        }
        onChange(data);
    }

    render() {
        const { data, beforeStartInvId } = this.props;
        const { blindInvId } = sessionStorage;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left"><Text asterisk colon>中心</Text></div>
                    <div className="item-right">
                        {
                            beforeStartInvId ?
                                <SearchRetrieve
                                    keyword="investigationSiteNameCode"
                                    style={{ width: 200 }}
                                    placeholder="输入中心编号/名称检索"
                                    value={data.siteName}
                                    params={{ limit: 20, investigationId: beforeStartInvId }}
                                    url={API_URL.investigation.queryInvestigationSiteList}
                                    config={{ id: 'investigationSiteId', name: 'investigationSiteName', code: 'investigationSiteCode', type: 'investigationSite', show: 'investigationSite' }}
                                    onChange={value => this.handleChange(value, 'site')}
                                /> :
                                <SearchRetrieve
                                    keyword="searchKey"
                                    style={{ width: 200 }}
                                    placeholder="输入中心编号/名称检索"
                                    value={data.siteName}
                                    params={{ limit: 20, invId: blindInvId, filterBlindAddSite: 'TRUE' }}
                                    url={API_URL.site.list}
                                    config={{ id: 'investigationSiteId', name: 'investigationSiteName', code: 'investigationSiteCode', type: 'site', show: 'site' }}
                                    onChange={value => this.handleChange(value, 'site')}
                                />
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk colon>关联JDE号</Text></div>
                    <div className="item-right">
                        <div>
                            <Input
                                placeholder="请选择"
                                style={{ width: 200 }}
                                onClick={this.handleClick}
                            />
                        </div>
                        <div style={{ marginTop: 4, maxHeight: 200, overflowY: 'auto' }}>
                            {
                                (data.contractVos || []).map((item, index) => {
                                    const { relatedType, investigationJdeContractId, investigationJdeContractCode } = item;
                                    return (
                                        <div key={investigationJdeContractId} style={{ margin: 4 }}>
                                            <Tag
                                                closable
                                                color="#DDD"
                                                className="close-color"
                                                style={{ color: 'rgba(0, 0, 0, .65)' }}
                                                onClose={() => this.handleDelete(index)}
                                            >
                                                <span
                                                    style={{
                                                        display: 'inline-block',
                                                        marginRight: '4px',
                                                        padding: '0px 4px',
                                                        color: '#FFF',
                                                        background: '#5750c9',
                                                        borderRadius: '50%',
                                                    }}
                                                >
                                                    {RelateType[relatedType].charAt(0)}
                                                </span>
                                                {investigationJdeContractCode}
                                            </Tag>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </li>
                <RelateJdeCode
                    ref={el => this.relateTypeRef = el}
                    onChange={value => this.handleChange(value, 'contractVos')}
                />
            </ul>
        );
    }
}

class AddCustom extends Component {
    
    state = {
        needCourtyardArea: false,
        stageList: [],
    }

    componentDidMount() {
        this.loadTypeConfigureList();
    }

    loadTypeConfigureList = () => {
        const options = {
            method: 'POST',
            url: API_URL.common.typeConfigureList,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({ 
                    stageList: res.stageList,
                });
            }
        }
        $.sendRequest(options)
    }

    handleClick = () => {
        const { data } = this.props;
        this.relateTypeRef.show(data.contractVos);
    }

    handleDelete = index => {
        const { data, onChange } = this.props;
        const { contractVos } = data;
        contractVos.splice(index, 1);
        onChange(data);
    }

    handleChange = (value, key) => {
        const { data, onChange } = this.props;
        
        switch (key) {
        case 'hospital': {
            const { value: id, text: name } = value;
            data.hospitalMainId = id;
            data.hospitalMainName = name;
            data.hospitalId = undefined;
            data.courtyardArea = undefined;
            data.departmentId = undefined;
            data.departmentName = undefined;
            data.siteName = name;
            id && this.queryCourtyardAreaList(id);
            break;
        }
        case 'courtyardArea': {
            const { value: id, text: name } = value;
            data.hospitalId = id;
            data.courtyardArea = name;
            data.departmentId = undefined;
            data.departmentName = undefined;
            break;
        }
        case 'department': {
            const { value: id, text: name, departmentId } = value;
            data.departmentId = id;
            data.departmentName = name;
            departmentId && this.queryHospitalDepartmentDetail(departmentId);
            break;
        }
        case 'stageIds': {
            const arr = value || [];
            const hasAllNumbers = this.checkArrayContains(arr);
            if (arr.length > 1) {
                if (hasAllNumbers) {
                    data[key] = arr;
                } else {
                    data[key] = [arr.pop()];
                }
            } else {
                data[key] = arr;
            }
            break;
        }
        default: {
            data[key] = value;
            break;
        }
        }
        onChange(data);
    }

    // 判断数组中是否只包含17,18,19
    checkArrayContains = (arr) => {
        const allowedNumbers = new Set(['17', '18', '19']); // 允许的数字集合
        // 条件1：数组不为空；条件2：所有元素都在允许集合中
        return arr.length > 0 && arr.every(num => allowedNumbers.has(num));
    }

    queryCourtyardAreaList = (id) => {
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryHospitalCourtyardAreaList,
            data: {    
                hospitalMainId: id,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas } = res;
                let { needCourtyardArea } = this.state;
                const { data, onChange } = this.props;
                needCourtyardArea = false;
                datas.map(i=>{
                    if (i.courtyardArea) {
                        needCourtyardArea = true;
                    }
                })
                data.hospitalId = datas[0].hospitalId;
                onChange(data);

                this.setState({ needCourtyardArea });
            }
        };
        $.sendRequest(options);
    }

    queryHospitalDepartmentDetail = (departmentId) => {
        const { data, onChange } = this.props;
        const { hospitalId } = data;
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryHospitalDepartmentDetail,
            data: {    
                hospitalId,
                departmentId,
            },
            dataType: 'json',
            doneResult: res => {
                const { hospitalDepartment = {} } = res;
                const { unblindingRisk, unblindingRiskLevelShow } = hospitalDepartment;
                data.unblindingRisk = unblindingRisk;
                data.unblindingRiskLevelShow = unblindingRiskLevelShow;
                onChange(data);
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { config, data } = this.props;
        const { needCourtyardArea, stageList } = this.state;
        const { hospitalMainName, hospitalMainId, courtyardArea, hospitalId } = data;
        const stageOption = (stageList || []).map(d => <Option value={String(d.typeConfigureId)} key={String(d.typeConfigureId)} title={d.typeValue}>{d.typeValue}</Option>);
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left"><Text asterisk colon>所属医院</Text></div>
                    <div className="item-right">
                        <SearchRetrieve
                            // disabled={config.edit}
                            keyword="hospitalName"
                            style={{ width: 200 }}
                            placeholder="输入医院名称检索"
                            value={hospitalMainName}
                            params={{ hospitalCity: config.edit ? data.cityName : undefined, limit: 10, offset: 1 }}
                            url={API_URL.hospital.queryHospitalMainList}
                            config={{ id: 'hospitalMainId', name: 'hospitalMainName'}}
                            onChange={value => this.handleChange(value, 'hospital')}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text colon>所属院区</Text></div>
                    <div className="item-right">
                        <SearchRetrieve
                            disabled={ !hospitalMainId }
                            keyword="courtyardArea"
                            style={{ width: 200 }}
                            placeholder="输入院区名称检索"
                            value={ courtyardArea?courtyardArea:undefined }
                            params={{ hospitalMainId }}
                            url={API_URL.hospital.queryHospitalCourtyardAreaList}
                            config={{ id: 'hospitalId', name: 'courtyardArea'}}
                            onChange={value => this.handleChange(value, 'courtyardArea')}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk colon>所属科室</Text></div>
                    <div className="item-right">
                        <SearchRetrieve
                            keyword="hospitalDepName"
                            style={{ width: 200 }}
                            placeholder="输入科室名称检索"
                            disabled={ !needCourtyardArea ? !hospitalMainId : !courtyardArea} 
                            value={data.departmentName}
                            params={{ limit: 20, hospitalId: hospitalId ? hospitalId : null }}
                            url={API_URL.hospital.queryDepWhenAddDoctor}
                            config={{ id: 'hospitalDepartmentId', name: 'departmentLocalName' }}
                            onChange={value => this.handleChange(value, 'department')}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk colon>中心名称</Text></div>
                    <div className="item-right">
                        <Input
                            disabled
                            placeholder="请输入"
                            value={data.siteName}
                            style={{ width: 200 }}
                            onChange={e => this.handleChange(e.target.value, 'siteName')}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk colon>中心编号</Text></div>
                    <div className="item-right">
                        <Input
                            placeholder="请输入"
                            value={data.siteCode}
                            style={{ width: 200 }}
                            onChange={e => this.handleChange(e.target.value, 'siteCode')}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk colon>研究中心项目阶段</Text></div>
                    <div className="item-right">
                        <Select
                            placeholder="请选择"
                            mode='multiple'
                            value={data.stageIds}
                            style={{ width: 200 }}
                            onChange={value => this.handleChange(value, 'stageIds')}
                        >
                            {stageOption}
                        </Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk colon>中心在项目内是否是组长单位</Text></div>
                    <div className="item-right">
                        <RadioGroup
                            value={data.groupLeaderUnit || 0}
                            onChange={e => this.handleChange(e.target.value, 'groupLeaderUnit')}
                        >
                            <Radio value={1}>是</Radio>
                            <Radio value={0}>否</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk colon>启动前是否津石负责</Text></div>
                    <div className="item-right">
                        <RadioGroup
                            value={data.groupManagerBeforeStart || 0}
                            onChange={e => this.handleChange(e.target.value, 'groupManagerBeforeStart')}
                        >
                            <Radio value={1}>是</Radio>
                            <Radio value={0}>否</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk colon>是否涉及中心调研</Text></div>
                    <div className="item-right">
                        <RadioGroup
                            value={data.relatedSiteSurvey || 0}
                            onChange={e => this.handleChange(e.target.value, 'relatedSiteSurvey')}
                        >
                            <Radio value={1}>是</Radio>
                            <Radio value={0}>否</Radio>
                        </RadioGroup>
                    </div>
                </li>
                {
                    data.relatedSiteSurvey == 1 &&
                    <li className="modal-item">
                        <div className="item-left"><Text colon>申办方是否选中</Text></div>
                        <div className="item-right">
                            <RadioGroup
                                value={data.sponsorSelected}
                                onChange={e => this.handleChange(e.target.value, 'sponsorSelected')}
                            >
                                <Radio value={1}>是</Radio>
                                <Radio value={0}>否</Radio>
                                <Radio value={-1}>待定</Radio>
                            </RadioGroup>
                        </div>
                    </li>
                }
                
                <li className="modal-item">
                    <div className="item-left"><Text asterisk colon>关联JDE号</Text></div>
                    <div className="item-right">
                        <div>
                            <Input
                                placeholder="请选择"
                                style={{ width: 200 }}
                                onClick={this.handleClick}
                            />
                        </div>
                        <div style={{ marginTop: 4, maxHeight: 200, overflowY: 'auto' }}>
                            {
                                (data.contractVos || []).map((item, index) => {
                                    const { relatedType, investigationJdeContractId, investigationJdeContractCode } = item;
                                    return (
                                        <div key={investigationJdeContractId} style={{ margin: 4 }}>
                                            <Tag
                                                closable
                                                color="#DDD"
                                                className="close-color"
                                                style={{ color: 'rgba(0, 0, 0, .65)' }}
                                                onClose={() => this.handleDelete(index)}
                                            >
                                                <span
                                                    style={{
                                                        display: 'inline-block',
                                                        marginRight: '4px',
                                                        padding: '0px 4px',
                                                        color: '#FFF',
                                                        background: '#5750c9',
                                                        borderRadius: '50%',
                                                    }}
                                                >
                                                    {RelateType[relatedType].charAt(0)}
                                                </span>
                                                {investigationJdeContractCode}
                                            </Tag>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </li>
                <RelateJdeCode
                    ref={el => this.relateTypeRef = el}
                    onChange={value => this.handleChange(value, 'contractVos')}
                />
            </ul>
        );
    }
}

export { AddFromBlind, AddCustom };



// WEBPACK FOOTER //
// ./src/components/site/researchCenterDetail/components/UpdateView.js